import { useState, useEffect } from "react";
import { collection, query, where, onSnapshot } from "firebase/firestore";
import { firestore } from "../lib/firebaseConfig";
import { useAuth } from "../context/AuthContext";
import NavItem from "./NavItem";
import investingIcon from "../assets/images/nav-icons/Inwestycje.svg";
import customersIcon from "../assets/images/nav-icons/customers.svg";
import paymentsIcon from "../assets/images/nav-icons/payments.svg";

const NAV_ITEMS = [
  {
    title: "Inwestycje",
    path: "/investments",
    icon: investingIcon,
  },
  {
    title: "Klienci",
    path: "/customers",
    icon: customersIcon,
  },
  {
    title: "Faktury",
    path: "/invoices",
    icon: paymentsIcon,
    isNew: false,
  },
  {
    title: "Wnioski",
    path: "/change-requests",
    icon: paymentsIcon,
    isNew: false,
  },
];

const MainNav = () => {
  const { canAccess } = useAuth();
  const [pendingInvoicesCount, setPendingInvoicesCount] = useState(0);
  const [pendingChangeRequests, setPendingChangeRequests] = useState(0);

  useEffect(() => {
    const q = query(
      collection(firestore, "stage_settlements"),
      where("status", "==", "pending")
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      setPendingInvoicesCount(snapshot.size);
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const q = query(
      collection(firestore, "changeRequests"),
      where("status", "==", "pending")
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      setPendingChangeRequests(snapshot.size);
    });

    return () => unsubscribe();
  }, []);

  // Filter nav items based on user role
  const visibleItems = NAV_ITEMS.filter((item) => canAccess(item.path));

  return (
    <nav className="mt-3.5">
      <ul>
        {visibleItems.map((item) => (
          <NavItem
            key={item.title}
            {...item}
            badge={
              item.title === "Faktury" ? pendingInvoicesCount
              : item.title === "Wnioski" ? pendingChangeRequests
              : undefined
            }
          />
        ))}
      </ul>
    </nav>
  );
};

export default MainNav;
